import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';

import { tierConfig } from 'constants/loyalty.constants';
import {
  LoyaltyBenefitFragment,
  LoyaltyTierName,
} from 'types/api/account.types';

interface Props {
  tier: LoyaltyTierName;
  benefits: Array<LoyaltyBenefitFragment>;
  sx?: SxProps<Theme>;
}

const LoyaltyCardPortraitBenefits = ({ tier, benefits, sx }: Props) => {
  const { textColor, borderColor, mixBlendMode } = tierConfig[tier];
  const activeBenefits = benefits.filter((benefit) => !!benefit.value);

  if (!activeBenefits.length) {
    return null;
  }

  return (
    <Stack
      sx={[
        {
          width: '100%',
          px: '10px',
          textAlign: 'center',
          pb: 3,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={{
          borderTop: '2px solid',
          borderColor: borderColor,
          mixBlendMode: mixBlendMode,
          mb: 2,
        }}
      />
      <Stack sx={{ opacity: 0.7, gap: 1 }}>
        {activeBenefits.map((benefit, index) => (
          <Typography
            key={`${benefit.label}-${index}`}
            variant="small"
            color={textColor}
          >
            {[benefit.label, benefit.value].join(' - ')}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default LoyaltyCardPortraitBenefits;
